export var noop = function () { };
//# sourceMappingURL=noop.js.map